import {
  useState,
  useEffect,
  useRef
} from "react";

import { renderAsync }
  from "docx-preview";

import {
  init
} from "pptx-preview";

import ExcelJS
  from "exceljs";

import ForwardFileModal
  from "./ForwardFileModal";

export default function FileViewerModal({

  isOpen,

  onClose,

  documentType,

  title,

  subtitle,

  date,

  fileUrl,

  filename,

  mimeType,

  onWhatsApp,

  sendingWhatsApp = false,

  showForward = true

}) {

const [
  zoom,
  setZoom
] = useState(1);

const [currentSlide, setCurrentSlide] = useState(1);

const [totalSlides, setTotalSlides] = useState(1);

const [pptZoom, setPptZoom] =
  useState(100);

const previewerRef =
  useRef(null);

const [
  workbookSheets,
  setWorkbookSheets
] = useState([]);

const [
  selectedSheet,
  setSelectedSheet
] = useState(0);

const [
  excelData,
  setExcelData
] = useState([]);

const [
  excelColumnWidths,
  setExcelColumnWidths
] = useState([]);

const [
  excelRowCount,
  setExcelRowCount
] = useState(0);

const [
  excelColumnCount,
  setExcelColumnCount
] = useState(0);

const [
  excelSearch,
  setExcelSearch
] = useState("");

const filteredExcelRows =

    excelData.filter((row,rowIndex)=>{

        if (
            rowIndex === 0
        ) {
            return true;
        }

        if (
            !excelSearch.trim()
        ) {
            return true;
        }

        return row.some(cell=>

            String(
                cell ?? ""
            )

            .toLowerCase()

            .includes(

                excelSearch
                .toLowerCase()

            )

        );

    });

const [
  excelWorkbook,
  setExcelWorkbook
] = useState(null);

const [
  forwardOpen,
  setForwardOpen
] = useState(false);

const docxContainerRef =
  useRef(null);

const pptxContainerRef =
  useRef(null);

    useEffect(() => {

    if (!isOpen) {

        setForwardOpen(false);

    }

    }, [isOpen]);

    useEffect(() => {

    if (isOpen) {

        setZoom(1);

    }

    }, [isOpen]);

    useEffect(() => {

        const isPptx =

            mimeType ===
            "application/vnd.openxmlformats-officedocument.presentationml.presentation"

            ||

            filename?.toLowerCase()
            .endsWith(".pptx");

        if (
            !isOpen ||
            !isPptx
        ) {
            return;
        }

        function handleKeyDown(event) {

            if (
                event.target.tagName === "INPUT" ||
                event.target.tagName === "TEXTAREA"
            ) {
                return;
            }

            if (event.key === "ArrowRight") {

                setCurrentSlide(current => {

                    if (
                        current >= totalSlides
                    ) {
                        return current;
                    }

                    const next =
                        current + 1;

                    previewerRef.current
                    ?.renderSingleSlide(
                        next - 1
                    );

                    return next;

                });

            }

            if (event.key === "ArrowLeft") {

                setCurrentSlide(current => {

                    if (
                        current <= 1
                    ) {
                        return current;
                    }

                    const previous =
                        current - 1;

                    previewerRef.current
                    ?.renderSingleSlide(
                        previous - 1
                    );

                    return previous;

                });

            }

        }

        window.addEventListener(
            "keydown",
            handleKeyDown
        );

        return () => {

            window.removeEventListener(
                "keydown",
                handleKeyDown
            );

        };

    }, [

        isOpen,

        mimeType,

        filename,

        totalSlides

    ]);

    useEffect(() => {

        async function loadDocx() {

            if (
            !fileUrl ||
            !mimeType
            ) {
            return;
            }

            const isDocx =

            mimeType ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"

            ||

            filename?.toLowerCase()
            .endsWith(".docx");

            if (!isDocx) {
            return;
            }

            try {

            const response =
                await fetch(
                fileUrl
                );

            const blob =
                await response.blob();

            if (
                docxContainerRef.current
            ) {

                docxContainerRef.current.innerHTML =
                "";

                await renderAsync(

                blob,

                docxContainerRef.current

                );

            }

            const pages =
                docxContainerRef.current.querySelectorAll(
                    ".docx"
                );

                pages.forEach(page => {

                page.style.maxWidth =
                    "100%";

                page.style.width =
                    "100%";

                page.style.margin =
                    "0 auto";

            });

            } catch(error) {

            console.error(
                "DOCX ERROR:",
                error
            );

            }

        }

        loadDocx();

        }, [
        fileUrl,
        mimeType,
        filename
    ]);

    useEffect(() => {

        async function loadPptx() {

            const isPptx =

            mimeType ===
            "application/vnd.openxmlformats-officedocument.presentationml.presentation"

            ||

            filename?.toLowerCase()
            .endsWith(".pptx");

            if (!isPptx) {
                return;
            }

            try {

                const response =
                    await fetch(fileUrl);

                const blob =
                    await response.blob();

                if (!pptxContainerRef.current) {
                    return;
                }

                pptxContainerRef.current.innerHTML = "";

                const previewer = init(

                    pptxContainerRef.current,

                    {

                        width: 1000,

                        height: 563,

                        mode: "slide"

                    }

                );

                previewerRef.current =
                previewer;

                await previewer.preview(
                    await blob.arrayBuffer()
                );

                setTimeout(() => {

                    const navButtons =

                    pptxContainerRef.current
                    ?.querySelectorAll(
                        ".pptx-preview-wrapper-next"
                    );

                    navButtons?.forEach(btn => {

                        btn.remove();

                    });

                    const pagination =

                    pptxContainerRef.current
                    ?.querySelector(
                        ".pptx-preview-wrapper-pagination"
                    );

                    if (pagination) {

                        pagination.remove();

                    }

                }, 500);

                console.log(
                    "SLIDES:",
                    previewer.slideCount
                );

                setTotalSlides(
                    previewer.slideCount || 1
                );

                setCurrentSlide(1);

                console.log(
                    "PPTX CONTAINER:",
                    pptxContainerRef.current
                );

                console.log(
                    "PPTX CHILDREN:",
                    pptxContainerRef.current.children.length
                );

                console.log(
                    "PPTX FIRST CHILD:",
                    pptxContainerRef.current.firstElementChild
                );

            } catch(error) {

                console.error(
                    "PPTX ERROR:",
                    error
                );

            }

        }

        loadPptx();

        }, [
        fileUrl,
        mimeType,
        filename
    ]);

    useEffect(() => {

        async function loadExcel() {

            const isExcel =

                mimeType ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

                ||

                filename?.toLowerCase()
                .endsWith(".xlsx");

            if (!isExcel) {
                return;
            }

            try {

                const response =
                    await fetch(fileUrl);

                const buffer =
                    await response.arrayBuffer();

                const workbook =
                    new ExcelJS.Workbook();

                await workbook.xlsx.load(buffer);

                    setExcelWorkbook(
                        workbook
                    );

                const sheetNames =
                    workbook.worksheets.map(
                        sheet => sheet.name
                    );

                setWorkbookSheets(
                    sheetNames
                );

                setSelectedSheet(0);

                loadExcelSheet(0);

            } catch(error) {

                console.error(
                    "EXCEL ERROR:",
                    error
                );

            }

        }

        loadExcel();

    }, [

        fileUrl,

        mimeType,

        filename

    ]);

    function loadExcelSheet(index) {

        if (!excelWorkbook) {
            return;
        }

        const sheet =
            excelWorkbook.worksheets[index];

        if (!sheet) {
            return;
        }

        const rows = [];

        const columnWidths = [];

        sheet.eachRow(row => {

            const values =
                row.values.slice(1);

            rows.push(values);

            values.forEach((value,column)=>{

                const length =

                    String(
                        value ?? ""
                    ).length;

                columnWidths[column] =

                    Math.max(

                        columnWidths[column] || 80,

                        Math.min(

                            length * 9 + 24,

                            450

                        )

                    );

            });

        });

        setExcelData(rows);

        setExcelColumnWidths(
            columnWidths
        );

        setExcelRowCount(
            rows.length
        );

        setExcelColumnCount(

            Math.max(

                ...rows.map(
                    row => row.length
                ),

                0

            )

        );

    }

  if (!isOpen) {
    return null;
  }

  return (

    <>

    <div

      onClick={onClose}

      style={{

        position:"fixed",

        inset:0,

        background:
          "rgba(0,0,0,0.6)",

        display:"flex",

        alignItems:"center",

        justifyContent:"center",

        zIndex:9999

      }}

    >

      <div

        onClick={e =>
          e.stopPropagation()
        }

        style={{

          width:"80vw",

          maxWidth:"1100px",

          height:"80vh",

          background:"#fff",

          borderRadius:16,

          display:"flex",

          flexDirection:"column",

          overflow:"hidden"

        }}

      >

        <div style={{

            padding:"14px 18px",

            borderBottom:
                "1px solid #e5e7eb",

            display:"flex",

            justifyContent:
                "space-between",

            alignItems:"center",

            flexWrap:"wrap",

            gap:10

            }}>

            <div>

                {documentType && (

                    <div style={{

                    fontSize:12,

                    fontWeight:700,

                    color:"#1e293b",

                    color:"#6b7280",

                    textTransform:"uppercase",

                    marginBottom:4

                    }}>

                    {documentType}

                    </div>

                )}

                <div style={{

                    fontSize:18,

                    fontWeight:700

                }}>

                    {title}

                </div>

                {subtitle && (

                    <div style={{

                    fontSize:14,

                    color:"#4b5563",

                    marginTop:2

                    }}>

                    {subtitle}

                    </div>

                )}

                {date && (

                    <div style={{

                    fontSize:12,

                    color:"#6b7280",

                    marginTop:4

                    }}>

                    {date}

                    </div>

                )}

                </div>

            <div style={{

                display:"flex",

                gap:10,

                alignItems:"center"

            }}>

                <button

                    onClick={async () => {

                        try {

                        const response =
                            await fetch(fileUrl);

                        const blob =
                            await response.blob();

                        const url =
                            window.URL.createObjectURL(
                            blob
                            );

                        const link =
                            document.createElement("a");

                        link.href = url;

                        link.download =
                            filename ||
                            "archivo";

                        document.body.appendChild(
                            link
                        );

                        link.click();

                        document.body.removeChild(
                            link
                        );

                        window.URL.revokeObjectURL(
                            url
                        );

                        } catch(error) {

                        console.error(error);

                        alert(
                            "Error descargando archivo"
                        );

                        }

                    }}

                    style={{

                        padding:"8px 12px",

                        background:"#e5e7eb",

                        borderRadius:8,

                        border:"none",

                        cursor:"pointer",

                        color:"#111827",

                        fontWeight:600

                    }}

                    >

                    Descargar

                </button>

                {showForward && (
                <button

                onClick={() =>
                    setForwardOpen(true)
                }

                disabled={
                    sendingWhatsApp
                }

                style={{

                    padding:"8px 12px",

                    background:"#16a34a",

                    color:"#fff",

                    border:"none",

                    borderRadius:8,

                    cursor:"pointer",

                    fontWeight:600,

                    opacity:
                    sendingWhatsApp
                        ? 0.6
                        : 1

                }}

                >

                {
                    sendingWhatsApp

                    ? "Enviando..."

                    : "Reenviar"
                }

                </button>
                )}

                <button

                onClick={onClose}

                style={{

                    border:"none",

                    background:"transparent",

                    fontSize:22,

                    cursor:"pointer",

                    fontWeight:700

                }}

                >

                ✕

                </button>

            </div>

            </div>

            {mimeType?.startsWith(
                "image/"
                ) && (

                <div style={{

                    display:"flex",

                    justifyContent:"center",

                    alignItems:"center",

                    gap:12,

                    padding:10,

                    borderBottom:
                    "1px solid #e5e7eb"

                }}>

                    <button

                    onClick={() =>

                        setZoom(z =>
                        Math.max(
                            0.25,
                            z - 0.25
                        )
                        )

                    }

                    >

                    ➖

                    </button>

                    <span>

                    {Math.round(
                        zoom * 100
                    )}%

                    </span>

                    <button

                    onClick={() =>

                        setZoom(z =>
                        Math.min(
                            5,
                            z + 0.25
                        )
                        )

                    }

                    >

                    ➕

                    </button>

                </div>

            )}

            {
                mimeType ===
                "application/vnd.openxmlformats-officedocument.presentationml.presentation"

                && (

                <div
                style={{
                    padding:"12px 16px",
                    borderBottom:"1px solid #e5e7eb",
                    display:"flex",
                    justifyContent:"center",
                    alignItems:"center",
                    gap:20,
                    background:"#fff"
                }}
                >

                <button

                onClick={() => {

                    if (
                    currentSlide <= 1
                    ) return;

                    previewerRef.current
                    ?.renderSingleSlide(
                        currentSlide - 2
                    );

                    setCurrentSlide(
                        s => s - 1
                    );

                }}

                >

                ◀

                </button>

                <div
                style={{
                    fontWeight:600
                }}
                >

                {currentSlide}
                {" / "}
                {totalSlides}

                </div>

                <button

                onClick={() => {

                    if (
                    currentSlide >= totalSlides
                    ) return;

                    previewerRef.current
                    ?.renderSingleSlide(
                        currentSlide
                    );

                    setCurrentSlide(
                        s => s + 1
                    );

                }}

                >

                ▶

                </button>

                <select

                    value={pptZoom}

                    onChange={e =>
                        setPptZoom(
                            Number(
                                e.target.value
                            )
                        )
                    }

                    style={{

                        padding:"8px 12px",

                        borderRadius:8,

                        border:"1px solid #d1d5db",

                        fontWeight:600

                    }}

                    >

                    <option value={50}>
                    50%
                    </option>

                    <option value={75}>
                    75%
                    </option>

                    <option value={100}>
                    100%
                    </option>

                    <option value={125}>
                    125%
                    </option>

                    <option value={150}>
                    150%
                    </option>

                    <option value={200}>
                    200%
                    </option>

                    </select>

                </div>

                )
            }

            {
                (
                    mimeType ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

                    ||

                    filename?.toLowerCase()
                    .endsWith(".xlsx")

                ) && (

                    <div
                    style={{

                        padding:"12px 18px",

                        borderBottom:"1px solid #e5e7eb",

                        background:"#ffffff",

                        display:"flex",

                        justifyContent:"space-between",

                        alignItems:"center",

                        flexWrap:"wrap",

                        gap:16

                    }}
                    >

                        <div
                        style={{
                            display:"flex",
                            alignItems:"center",
                            gap:12
                        }}
                        >

                            <span
                            style={{
                                fontWeight:700,
                                color:"#1e293b"
                            }}
                            >

                                Hoja:

                            </span>

                            <select

                                value={selectedSheet}

                                onChange={e => {

                                    const index =
                                        Number(
                                            e.target.value
                                        );

                                    setSelectedSheet(
                                        index
                                    );

                                    loadExcelSheet(
                                        index
                                    );

                                }}

                                style={{

                                    padding:"8px 14px",

                                    borderRadius:8,

                                    border:"1px solid #d1d5db",

                                    background:"#fff",

                                    minWidth:180,

                                    fontWeight:600,

                                    cursor:"pointer"

                                }}

                            >

                                {

                                workbookSheets.map(

                                    (name,index)=>(

                                        <option

                                            key={index}

                                            value={index}

                                        >

                                            {name}

                                        </option>

                                    )

                                )

                                }

                            </select>

                            <input

                                type="text"

                                placeholder="Buscar..."

                                value={excelSearch}

                                onChange={e =>

                                    setExcelSearch(
                                        e.target.value
                                    )

                                }

                                style={{

                                    width:220,

                                    padding:"8px 12px",

                                    border:"1px solid #d1d5db",

                                    borderRadius:8,

                                    outline:"none",

                                    fontSize:14

                                }}

                            />

                        </div>

                        <div
                        style={{

                            display:"flex",

                            alignItems:"center",

                            gap:20,

                            fontSize:13,

                            color:"#64748b",

                            fontWeight:600

                        }}
                        >

                            <div>

                                Filas:

                                <span
                                style={{
                                    marginLeft:6,
                                    color:"#111827",
                                    fontWeight:700
                                }}
                                >

                                    {excelRowCount}

                                </span>

                            </div>

                            <div>

                                Columnas:

                                <span
                                style={{
                                    marginLeft:6,
                                    color:"#111827",
                                    fontWeight:700
                                }}
                                >

                                    {excelColumnCount}

                                </span>

                            </div>

                        </div>

                    </div>

                )

            }

        <div style={{

            flex:1,

            display:"flex",

            alignItems:"stretch",

            justifyContent:"flex-start",

            overflow:"auto",

            background:"#f8fafc"

            }}>

            {mimeType?.startsWith(
                "image/"
            ) && (

                <img

                src={fileUrl}

                alt={filename}

                style={{

                    maxWidth:"100%",

                    maxHeight:"100%",

                    objectFit:"contain",

                    transform:
                        `scale(${zoom})`,

                    transition:
                        "transform 0.15s"

                    }}

                />

            )}

            {mimeType ===
                "application/pdf" && (

                <iframe

                title="pdf-viewer"

                src={fileUrl}

                style={{

                    width:"100%",

                    height:"100%",

                    border:"none"

                }}

                />

            )}

            {
                (
                    mimeType ===
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"

                    ||

                    filename?.toLowerCase()
                    .endsWith(".docx")

                ) && (

                    <div

                    ref={docxContainerRef}

                    style={{

                        width:"100%",

                        height:"100%",

                        overflow:"auto",

                        background:"#ffffff",

                        padding:"10px 20px"

                    }}

                    />

                )
            }

            {
                (
                    mimeType ===
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation"

                    ||

                    filename?.toLowerCase()
                    .endsWith(".pptx")

                ) && (

                <div
                style={{
                    width:"100%",
                    height:"100%",
                    display:"flex",
                    background:"#e2e8f0"
                }}
                >

                    <div
                    style={{
                        flex:1,
                        overflow:"auto",
                        background:"#ffffff"
                    }}
                    >

                        <div
                            style={{
                                width:"100%",
                                overflow:"auto",
                                display:"flex",
                                justifyContent:"center",
                                alignItems:"flex-start",
                                padding:"10px"
                            }}
                            >

                            <div

                                ref={pptxContainerRef}

                                style={{

                                    display:"inline-block",

                                    transform:
                                        `scale(${pptZoom / 100})`,

                                    transformOrigin:
                                        "top center"

                                }}
                            />

                        </div>

                    </div>

                </div>

                )
            }

            {
                (
                    mimeType ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

                    ||

                    filename?.toLowerCase()
                    .endsWith(".xlsx")

                ) && (

                    <div
                    style={{
                        width:"100%",
                        height:"100%",
                        overflow:"auto",
                        background:"#fff",
                        padding:20
                    }}
                    >

                        <div
                        style={{
                            width:"100%",
                            height:"100%",
                            overflow:"auto",
                            border:"1px solid #e5e7eb",
                            borderRadius:10
                        }}
                        >

                            <table
                            style={{
                                borderCollapse:"collapse",
                                width:"100%",
                                tableLayout:"auto"
                            }}
                            >

                                <tbody>

                                    {

                                        filteredExcelRows.length <= 1 ? (

                                            <tr>

                                                <td

                                                    colSpan={
                                                        excelColumnCount || 1
                                                    }

                                                    style={{

                                                        padding:"40px",

                                                        textAlign:"center",

                                                        color:"#64748b",

                                                        fontSize:15,

                                                        fontStyle:"italic"

                                                    }}

                                                >

                                                    No se encontraron resultados.

                                                </td>

                                            </tr>

                                        ) : (

                                            filteredExcelRows.map((row,rowIndex)=>(

                                                <tr key={rowIndex}>

                                                    {

                                                    row.map((cell,columnIndex)=>(

                                                        <td

                                                            key={columnIndex}

                                                            title={String(cell ?? "")}

                                                            onDoubleClick={()=>

                                                                navigator.clipboard.writeText(

                                                                    String(cell ?? "")

                                                                )

                                                            }

                                                            style={{

                                                                border:"1px solid #e5e7eb",

                                                                padding:"10px 14px",

                                                                width:

                                                                    excelColumnWidths[
                                                                        columnIndex
                                                                    ] || 120,

                                                                minWidth:

                                                                    excelColumnWidths[
                                                                        columnIndex
                                                                    ] || 120,

                                                                whiteSpace:"nowrap",

                                                                overflow:"hidden",

                                                                textOverflow:"ellipsis",

                                                                background:

                                                                    rowIndex === 0

                                                                    ? "#f1f5f9"

                                                                    : rowIndex % 2 === 0

                                                                    ? "#ffffff"

                                                                    : "#fafafa",

                                                                fontWeight:

                                                                    rowIndex === 0

                                                                    ? 700

                                                                    : 400,

                                                                position:

                                                                    rowIndex === 0

                                                                    ? "sticky"

                                                                    : "static",

                                                                top:

                                                                    rowIndex === 0

                                                                    ? 0

                                                                    : undefined,

                                                                zIndex:

                                                                    rowIndex === 0

                                                                    ? 2

                                                                    : 1,

                                                                cursor:"default"

                                                            }}

                                                        >

                                                            {String(cell ?? "")}

                                                        </td>

                                                    ))

                                                    }

                                                </tr>

                                            ))

                                        )

                                    }

                                </tbody>

                            </table>

                        </div>

                    </div>

                )

            }

            {mimeType?.startsWith(
                "audio/"
            ) && (

                <audio

                controls

                src={fileUrl}

                style={{
                    width:"90%"
                }}

                />

            )}

            {
                !mimeType?.startsWith(
                "image/"
                ) &&

                mimeType !==
                "application/pdf" &&

                !mimeType?.startsWith(
                "audio/"
                ) &&

                mimeType !==
                "application/msword" &&

                mimeType !==
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&

                mimeType !==
                "application/vnd.openxmlformats-officedocument.presentationml.presentation" &&

                !filename?.toLowerCase()
                .endsWith(".pptx") &&

                mimeType !==
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&

                !filename?.toLowerCase()
                .endsWith(".xlsx") && (

                    <div style={{

                    textAlign:"center"

                    }}>

                    <div style={{
                        fontSize:80
                    }}>

                        📎

                    </div>

                    <div>

                        {filename}

                    </div>

                    </div>

            )}

        </div>

            </div>

    </div>

    <ForwardFileModal

      isOpen={forwardOpen}

      onClose={() =>
        setForwardOpen(false)
      }

      fileUrl={fileUrl}

      filename={filename}

      mimeType={mimeType}

    />

  </>

);

}